import { GKSideModal, Show, Typography } from "components";
import Basket from "./Basket";
import MutualFunds from "./MutualFunds";

type OrderType = "basket" | "mutualFund";

const SideModal = ({
  open,
  orderType,
  onClose,
}: {
  open: boolean;
  orderType: OrderType | null;
  onClose: () => void;
}) => {
  return (
    <GKSideModal
      open={open}
      onClose={onClose}
      setOpen={onClose}
      width="100%"
      modalTitle={
        <Typography fontSize={18} fontWeight={700}>
          Create Order
        </Typography>
      }
      disablePadding
    >
      <Show.When isTrue={orderType === "basket"}>
        <Basket />
      </Show.When>
      <Show.When isTrue={orderType === "mutualFund"}>
        <MutualFunds onSuccess={onClose} />
      </Show.When>
    </GKSideModal>
  );
};

export default SideModal;
